import { FieldTypes } from '../../constants'
import { addFieldRow } from '../../fields'
import { DateTimeField, DropdownField, FieldMap, NumberField, TextField } from '../../types'
import { MedicationCategory, MedicationRoute, MedicationType, MedicationUnit } from '../types'

const medNameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Medication Name',
}

const categoryField: DropdownField<MedicationCategory> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Category',
  inputType: 'radio',
  options: [
    { text: 'Induction / Augmentation', id: MedicationCategory.INDUCTION },
    { text: 'Pain Management', id: MedicationCategory.PAIN_MGMT },
    { text: 'Antibiotic', id: MedicationCategory.ANTIBIOTIC },
    { text: 'Emergency', id: MedicationCategory.EMERGENCY },
  ],
}

const typeField: DropdownField<MedicationType> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Administration Type',
  inputType: 'radio',
  options: [
    { text: 'Bolus (one-time)', id: MedicationType.BOLUS },
    { text: 'Infusion (continuous)', id: MedicationType.INFUSION },
  ],
}

const doseField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Dose',
  min: 0,
  step: 0.1,
  precision: 2,
}

const unitField: DropdownField<MedicationUnit> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Unit',
  options: [
    { text: 'mg', id: MedicationUnit.MG },
    { text: 'mcg', id: MedicationUnit.MCG },
    { text: 'mU/min', id: MedicationUnit.MU_PER_MIN },
    { text: 'ml/hr', id: MedicationUnit.ML_PER_HR },
  ],
}

const routeField: DropdownField<MedicationRoute> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Route',
  inputType: 'radio',
  options: [
    { text: 'IV', id: MedicationRoute.IV },
    { text: 'IM', id: MedicationRoute.IM },
    { text: 'PO', id: MedicationRoute.PO },
    { text: 'Epidural', id: MedicationRoute.EPIDURAL },
  ],
}

const siteField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Administration Site',
  optional: true,
}

const startedAtField: DateTimeField = {
  type: FieldTypes.DATETIME,
  placeholder: 'Started At',
  defaultToNow: true,
}

const stoppedAtField: DateTimeField = {
  type: FieldTypes.DATETIME,
  placeholder: 'Stopped At',
  optional: true,
  condition: v => v?.type === MedicationType.INFUSION,
}

export const medicationField: FieldMap = {
  name: 'Medication',
  children: {
    medName: medNameField,
    category: addFieldRow(categoryField, { index: 1, flex: 1 }),
    type: addFieldRow(typeField, { index: 1, flex: 1 }),
    dose: addFieldRow(doseField, { index: 2, flex: 2 }),
    unit: addFieldRow(unitField, { index: 2, flex: 1 }),
    route: addFieldRow(routeField, { index: 3, flex: 1 }),
    site: addFieldRow(siteField, { index: 3, flex: 1 }),
    startedAt: addFieldRow(startedAtField, { index: 4, flex: 1 }),
    stoppedAt: addFieldRow(stoppedAtField, { index: 4, flex: 1 }),
  },
}
